/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { useEffect, useState } from "react";
import {
  Route,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";
import { PrivateRouterProps } from "../interface/route-interface";
import Header from "../components/shared-ui/header";
import { useOktaAuth } from "@okta/okta-react";
import _ from "lodash";
import ErrorScreen from "../components/shared-ui/errors/error-screen";
import { msalInstance } from "../core/authentication/entra/msal";

/**
 * This function is used for internal routing.
 *
 * @namespace PrivateRoute
 */
export const PrivateRoute: React.FC<PrivateRouterProps & RouteComponentProps> =
  ({ path, exact, component: Component, key, ...rest }: PrivateRouterProps) => {
    const { authState } = useOktaAuth();
    const [offline, setoffline] = useState(false);
    const isAssessmentDone =
      localStorage.getItem("isAssessmentDone") ||
      localStorage.getObj("reco-result") ||
      false;
    const userConsent = localStorage.getObj("user-consent");
    const isAdminAuthenticated = !!msalInstance.getAllAccounts()?.length;
    useEffect(() => {
      window.addEventListener("offline", handleOffline);
    });

    const handleOffline = () => {
      setoffline(true);
    };

    const tryAgain = () => {
      window.location.reload();
    };
    return offline ? (
      <ErrorScreen
        errorTitle={rest.t("error.connection_error")}
        handleErrorBtn={() => {
          tryAgain();
        }}
        errorBtnName={rest.t("error.error_button_try_again")}
        withBtn
      />
    ) : (
      <>
        <Header {...rest} authState={authState} showHeader={true}/>
        <Route
          key={key}
          path={path}
          exact={exact}
          // match={match}
          {...rest}
          render={(props: any) =>
            !isAdminAuthenticated && (props.location.pathname === "/admin/dashboard" || props.location.pathname === "/admin/testlist") ? (
              <Redirect
                to={{
                  pathname: "/admin",
                }}
              />
            ) :
              userConsent !== "accepted" &&
                (props.location.pathname === "/foundational" ||
                  props.location.pathname === "/results" ||
                  props.location.pathname.includes("summary")) ? (
                <Redirect
                  to={{
                    pathname: "/home",
                  }}
                />
              ) : !isAssessmentDone &&
                (props.location.pathname === "/results" ||
                  props.location.pathname.includes("summary")) ? (
                <Redirect
                  to={{
                    pathname: "/home",
                  }}
                />
              ) : (
                <Component {...props} {...rest} authState={authState} />
              )
          }
        />
      </>
    );
  };

const withRouterPrivateRoute = withRouter(PrivateRoute);
export default withRouterPrivateRoute;
